import { createContext } from "react";
import IAlertContext from "../../types/AlertState";
// import { AlertColor } from "@mui/material/Alert";

const defaultState: IAlertContext = {
  message: "",
  title: "Info",
  messageType: "success",
  ui: "dialog",
  show: false,
  alertType: "information",
};

const AlertContext = createContext<IAlertContext>(defaultState);

export default AlertContext;
